module.exports = __webpack_public_path__ + "supplier/img/empty.29feb83c.png";